export default __webpack_public_path__ + "static/media/bg-trash.49fe9ada.svg";